import React, { useCallback, useEffect, useState } from 'react';
import { Col, Modal, Row, Tabs, Card, Form } from 'antd';
import IUpdate from 'icons/IUpdate';
import IAdd from 'icons/IAdd';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import ButtonOperation from 'components/ButtonOperation';
import Bank from 'components/Bank';
import { useForm } from 'antd/lib/form/Form';
import { Checkbox, Input } from 'antd';
import { useGetProductList } from 'pages/ProposalV3/PropDetail/ProductInput';
import { indexBy } from 'utils/utils2';
export type BankAccountsListModalProps = {
  tpid: number;
  record?: any;
  onClose?: any;
  visible: boolean;
  updateAddress?: boolean;
  onSave: (add: any) => void;
  initadd: any;
  showAsModal?: boolean;
  countcode: string;
  currcode: string;
};

const BankAccountsListModal = (props: BankAccountsListModalProps) => {
  const {
    onClose,
    onSave,
    initadd,
    visible = false,
    record,
    countcode,
    currcode,
    showAsModal,
    tpid,
  } = props;

  const [form] = useForm();

  const [state, setstate] = useState<any>({
    record: initadd,
  });

  const { data: products } = useGetProductList();

  const reset = () => {
    setstate({ ...state, record: initadd });
  };

  useEffect(() => {
    if (record) {
      const productCheckboxValues: { [key: string]: boolean } = {};
      const productPriorityValues: { [key: string]: number } = {};
      if (record.tpBankAccountProductList) {
        record.tpBankAccountProductList.forEach((product: any) => {
          productCheckboxValues[product.prcode] = true;
          productPriorityValues[product.prcode] = product.priority;
        });
      }
      form.setFieldsValue({
        tpbkid: record.tpbkid,
        bkaccountkey: record.bkaccountkey,
        bkaccountnum: record.bkaccountnum,
        bkbranchcode: record.bkbranchcode,
        bkcode: record.bkcode,
        bktype: record.bktype,
        currcode: record.currcode,
        tpbic: record.tpbic,
        tpiban: record.tpiban,
        tpbankname: record.tpbankname,
        tpcbtype: record.tpcbtype,
        ...productCheckboxValues,
        priority: productPriorityValues,
      });
    } else {
      form.setFieldsValue(initadd);
    }
  }, [form, record, initadd]);

  const handleSubmit = (values: any) => {
    const tpbkid = form.getFieldValue('tpbkid');

    const tpBankAccountProductList = products
      ?.filter((product) => values[product.prcode])
      .map((product) => ({
        tpid: tpid,
        tpbkid: tpbkid,
        prcode: product.prcode,
        priority: parseInt(values.priority[product.prcode], 10),
      }));

    return tpBankAccountProductList;
  };
  return (
    <Modal
      open={visible}
      title={record ? 'Update Bank Account' : 'Add Bank Account'}
      width="1200px"
      style={{ top: 100 }}
      footer={null}
      destroyOnClose
      onCancel={() => {
        onClose();
        setstate({ record: initadd });
        reset();
      }}
    >
      <Form
        form={form}
        onFinish={(e) => {
          const tpBankAccountProductList = handleSubmit(e);
          const { priority, ...rest } = e;
          const cleanedValues = Object.keys(rest).reduce(
            (acc: { [key: string]: any }, key: string) => {
              if (!products?.some((product) => product.prcode === key)) {
                acc[key] = rest[key];
              }
              return acc;
            },
            {}
          );

          const tpbkid = form.getFieldValue('tpbkid');
          const tpid = form.getFieldValue('tpid');
          const submissionData = {
            
              ...cleanedValues,
              tpBankAccountProductList,
              ...(tpbkid ? { tpbkid } : {}),
              ...(tpid ? { tpid } : {}),
            
          };
          console.log('i am bankAccoountsModal e=>', submissionData);
          onSave(submissionData);
          setstate({ record: initadd });
          //   onClose();
        }}
      >
        <Tabs
          type="card"
          tabBarExtraContent={
            !showAsModal && (
              <Row gutter={16}>
                <Col>
                  <ButtonOperation comcode="Cancel" onClick={onClose} />
                </Col>
                <Col>
                  <ButtonOperation
                    icon={record ? <IUpdate></IUpdate> : <IAdd></IAdd>}
                    comcode={record ? 'Update' : 'Add'}
                    htmlType="submit"
                  />
                </Col>
              </Row>
            )
          }
        ></Tabs>

        <Card bordered>
          <Row gutter={16}>
            <FormInput col xs={12} name="bktype" labelCol={{ span: 5 }}>
              <ParListSelect
                parcode="PAYDIR"
                disabled={record || showAsModal}
              />
            </FormInput>
            <FormInput col xs={6} name="currcode" labelCol={{ span: 10 }}>
              <ParListSelect parcode="CURRENCY" />
            </FormInput>
            <Bank
              form={form}
              countcode={countcode}
              currcode={currcode}
              colU={12}
              bankField="bkcode"
              branchField="bkbranchcode"
              cbkeyField="bkaccountkey"
              cbnumField="bkaccountnum"
              ibanField="tpiban"
              bicField="tpbic"
              banknameField="tpbankname"
            />
          </Row>
          <Row gutter={[20, 20]} style={{ marginTop: '1em' }} >
            {products?.map((product, index) => (
              <React.Fragment key={product.prcode}>
                <Col>
                  <Form.Item
                    name={product.prcode}
                    valuePropName="checked"
                    label={product.prcode}
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Form.Item
                  shouldUpdate={(prevValues, curValues) =>
                    prevValues[product.prcode] !== curValues[product.prcode]
                  }
                >
                  {() =>
                    form.getFieldValue(product.prcode) ? (
                      <Col>
                        <Form.Item
                          name={['priority', product.prcode]}
                          label="Priority"
                        >
                          <ParListSelect parcode="BKPRIORITY" />
                        </Form.Item>
                      </Col>
                    ) : null
                  }
                </Form.Item>
              </React.Fragment>
            ))}
          </Row>
        </Card>
      </Form>
    </Modal>
  );
};

export default BankAccountsListModal;
